import { makeStyles } from '@material-ui/core/styles';

const BaseCardStyles =
    makeStyles((theme) => ({
        baseCardContainer: {
            display: "flex",
            height: "100%",
            overflow: "hidden",
            position: "relative",
            width: "100%",

            /*[theme.breakpoints.only("md")]: {
                height: "250px",
            },
            [theme.breakpoints.only("lg")]: {
                height: "320px",
            },
            [theme.breakpoints.only("xl")]: {
                height: "310px",
            },*/
        },
        baseCardContentContainer: {
            padding: theme.spacing(3),
            position: "relative",
        },
        baseCardContentContainerImgSml: {
            width: "80%",
        },
        baseCardContentContainerImgMd: {
            width: "55%",
        },
        baseCardContentContainerImgLg: {
            padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
            width: "40%",
        },
        baseCardImgContainer: {
            verticalAlign: "middle",
            height: "100%",
            position: "absolute",
            right: 0,
            top: 0,
        },
        baseCardImgContainerSml: {
            width: "20%",
        },
        baseCardImgContainerMd: {
            width: "45%",
        },
        baseCardImgContainerLg: {
            width: "60%",
        },
        baseCardImg: {
            width: "100%",
            height: "100%",
            display: "flex",
        },
    }));

export default BaseCardStyles;
